import React, { useContext, memo } from "react";
import { Link } from "react-router-dom";
import { Icon, Loader } from "rsuite";
import { AlbumsContext } from "../../context/albums.context";

function AlbumsList() {
  const { albums } = useContext(AlbumsContext);
  // console.log("albums", albums);
  if (albums) {
    return albums.map((item) => {
      return (
        <Link to={`/albums/${item.id}`}>
          <div className="albumCard">
            <Icon icon="folder-open" size="5x" />
            <h4>{item.name}</h4>
          </div>
        </Link>
      );
    });
  } else {
    return <Loader size="lg" speed="normal" />;
  }
}

export default memo(AlbumsList);
